<div class="popup popup-basic" class="strategy__viewer">
  <div class="popup-body strategy__viewer__diagram" fxLayout="row wrap">
    <div fxFlex #strategyLayoutTarget (selection)="select($event)" (remove)="remove($event)"></div>
  </div>
</div>
